module.exports = __webpack_public_path__ + "img/magnifying-glass.4e85fe06.svg";